
import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import HowItWorks from '@/components/HowItWorks';
import Benefits from '@/components/Benefits';
import Testimonials from '@/components/Testimonials';
import PricingSection from '@/components/PricingSection';
import CallToAction from '@/components/CallToAction';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { Container } from '@/components/layout/container';
import { TypographyH2, TypographyBody } from '@/components/ui/typography';
import { useAuth } from '@/hooks/useAuth';

const Index = () => {
  const { user } = useAuth();

  // If user is already logged in, redirect to appropriate page
  if (user) {
    return <Navigate to={user.user_metadata?.user_role === 'journalist' ? '/dashboard' : '/home'} />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-white text-directpress-dark">
      <Navbar />
      <main className="flex-grow">
        <HeroSection />
        <div className="py-12 bg-directpress-light/30">
          <Container>
            <div className="text-center">
              <TypographyH2 className="mb-6 text-directpress-dark">Join DirectPress Today</TypographyH2>
              <TypographyBody className="text-gray-600 max-w-2xl mx-auto mb-8">
                Whether you're a journalist looking to share your expertise or a reader seeking quality content,
                DirectPress has the perfect onboarding experience for you.
              </TypographyBody>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/auth?role=reader">
                  <Button size="lg" variant="default" className="w-full sm:w-auto">
                    I'm a Reader
                  </Button>
                </Link>
                <Link to="/auth?role=journalist">
                  <Button size="lg" variant="tertiary" className="w-full sm:w-auto">
                    I'm a Journalist
                  </Button>
                </Link>
              </div>
            </div>
          </Container>
        </div>
        <HowItWorks />
        <Benefits />
        <Testimonials />
        <PricingSection />
        <CallToAction />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
